module.exports = __webpack_public_path__ + "img/Search.52f8c82c.png";